import { Flex, selectTheme, styled } from '@creditas-ui/react';

type StyleProps = { isOpen?: boolean; width?: string };

export const ModalContainer = styled.div`
  display: flex;
  position: fixed;
  width: 600px;
  right: -20px;
  bottom: 5%;
  top: 5%;
  z-index: 1;
`;

export const ModalBlind = styled.div`
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  z-index: 2;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  overflow-x: auto;
`;

export const ModalBox = styled.div<StyleProps>`
  width: 768px;
  min-width: 300px;
  max-width: calc(100% - 20px);
  min-height: 200px;
  max-height: calc(100% - 20px);
  background-color:${selectTheme('colors.neutral.0')};
  box-shadow: 0 1px 2px 0 ${selectTheme('colors.neutral.90')}, 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  z-index: 3;
  position: relative;
  transition: 0.4s;
  transform: translate(0, -100%);
  opacity: 0;
  ${(props) =>
    props.isOpen &&
    `
      transform: translate(0,0);
      opacity: 1;
    `}
`;

export const ModalHeader = styled(Flex)`
  border-bottom: 1px solid rgba(237, 240, 239, 1);
  align-items: center;
  justify-content: space-between;
  padding: 32px;
`;

export const IconWrapper = styled.button<Record<string, unknown>>`
  border: none;
  border-radius: 6px;
  background: none;
  &:hover {
    cursor: pointer;
  }
`;
